<template>
	<span :class="clsx(className, 'grow basis-0')">
		<VButton
			:href="href ? href : undefined"
			:disabled="href === null ? true : false"
			plain
			aria-label="Previous page">
			<svg
				class="stroke-current"
				data-slot="icon"
				viewBox="0 0 16 16"
				fill="none"
				aria-hidden="true">
				<path
					d="M2.75 8H13.25M2.75 8L5.25 5.5M2.75 8L5.25 10.5"
					stroke-width="{1.5}"
					stroke-linecap="round"
					stroke-linejoin="round" />
			</svg>
			{{ children }}
		</VButton>
	</span>
</template>

<script lang="ts">
	export default { name: 'VPaginationPrevious' } // name the component
</script>

<script setup lang="ts">
	import VButton from '@/components/Buttons/VButton.vue'

	import { 
		clsx
	} from 'clsx'

	const props = defineProps({
		className: {
			type: String,
			default: ''
		},
		children: {
			type: String,
			default: "Previous"
		},
		href: {
			type: String,
			default: null
		}
	})
</script>